import { __ } from '~@/Composables/translation'

export default [
    { value: 'placeholder', example: __('tools.emails.placeholders.help_on_template_logic.placeholder'), link: '' },
    { value: 'if', example: '', link: 'https://laravel.com/docs/10.x/blade#if-statements' },
    { value: 'switch', example: '', link: 'https://laravel.com/docs/10.x/blade#switch-statements' },
    { value: 'for/foreach', example: '', link: 'https://laravel.com/docs/10.x/blade#loops' },
    { value: 'links', example: '[Google](https://www.google.co.uk/)', link: '' },
    { value: 'bold', example: '**text**', link: '' },
    { value: 'italic', example: '_text_', link: '' },
    {
        value: 'heading',
        example: '' +
            '# John\n' +
            '## John\n' +
            '### John',
        link: ''
    },
    {
        value: 'list',
        example: '' +
            '- John\n' +
            '- Paul\n' +
            '- George',
        link: ''
    },
    {
        value: 'list-numbered',
        example: '' +
            '1. John\n' +
            '1. Paul\n' +
            '1. George',
        link: ''
    },
    {
        value: 'component',
        example: '' +
            '@component(\'mail::button\', [\'url\' => \'URL\'])\n' +
            '        TEXT\n' +
            '@endcomponent',
        link: ''
    },
    { value: 'linebreaks', example: '<br>', link: '' },
    { value: 'text size', example: __('tools.emails.placeholders.help_on_template_logic.text_size'), link: '' },
]
